<template>
  <div class="fddform-no-date">
    <span class="use-none" />
    <slot>
      <p>{{ message }}</p>
    </slot>
  </div>
</template>
<script>
  export default {
    name: 'NoData',
    props: {
      message: {
        type: String,
        default: '暂未发现相关数据'
      }
    }
  }
</script>
